import { Empty } from "antd";
import React, { useEffect } from "react";
import CleanButton from "../../../common/components/CleanButton";
import Page from "../../../common/components/Page";
import ChangePassword from "./changePassword";
import UpdateEmailLoginForm from "./updateEmailLogin";
import useProfile from "./useProfile";

const Profile = ({ ...props }) => {
  const { setIsChangePassword, setIsUpdateLoginEmail, setIsUpdateRecoveryInfo, isChangePassword, isUpdateLoginEmail, isUpdateRecoverInfo, form } = useProfile();

  const handlePasswordForm = () => {
    setIsChangePassword(true);
    setIsUpdateLoginEmail(false);
    setIsUpdateRecoveryInfo(false);
  };

  const handleLoginEmailForm = () => {
    setIsChangePassword(false);
    setIsUpdateLoginEmail(true);
    setIsUpdateRecoveryInfo(false);
  };

  const handleRecoveryForm = () => {
    setIsChangePassword(false);
    setIsUpdateLoginEmail(false);
    setIsUpdateRecoveryInfo(true);
  };

  return (
    <Page>
      <Page.Title title="Profile" icon="user" />
      {/* <Page.Toolbar>
        <CleanButton icon="lock" onClick={handlePasswordForm}>
          Change Password
        </CleanButton>
        <CleanButton icon="user" onClick={handleRecoveryForm}>
          Update Recovery Information
        </CleanButton>
        <CleanButton icon="user" onClick={handleLoginEmailForm}>
          Update Login ID / Email Address
        </CleanButton>
      </Page.Toolbar> */}
      <Page.Content>
        {/* {!isUpdateLoginEmail && !isUpdateRecoverInfo && <ChangePassword />}
        {isUpdateLoginEmail && <UpdateEmailLoginForm />}
        {isUpdateRecoverInfo && <Empty></Empty>} */}
        <ChangePassword />
      </Page.Content>
    </Page>
  );
};

export default Profile;
